import * as sunsetApi from '../api/sunset'
import { createSlice } from '@reduxjs/toolkit'
import { error } from 'react-notification-system-redux'

const sunset = createSlice({
  name: 'sunset',
  initialState: {
    isFetching: false,
    isUpdating: false,
    sunset: {
      gotSunsetRefund: false,
      gotBeatportCredit: false,
      gotBeatportMigrated: false,
      sunsetRefundAmount: 0,
      sunsetRefundCurrency: 'USD',
      beatportCreditAmountInUSD: 0,
      beatportCouponCode: '',
    },
    error: null,
    sunsetModeStatus: false,
    preSunsetModeStatus: false,
  },
  reducers: {
    requestSunset: state => {
      return {
        ...state,
        isFetching: true,
      }
    },
    receiveSunset: (state, action) => {
      return {
        ...state,
        isFetching: false,
        sunset: action.payload.sunset,
      }
    },
    errorReceivingSunset: (state, action) => {
      return {
        ...state,
        isFetching: false,
        error: action.payload.err.message,
      }
    },
    settingSunset: state => {
      return {
        ...state,
        isUpdating: true,
      }
    },
    setSunset: (state, action) => {
      return {
        ...state,
        isUpdating: false,
        sunset: {
          ...state.sunset,
          gotSunsetRefund:
            action.payload.gotSunsetRefund || state.sunset.gotSunsetRefund,
          gotBeatportCredit:
            action.payload.gotBeatportCredit || state.sunset.gotBeatportCredit,
          gotBeatportMigrated:
            action.payload.gotBeatportMigrated ||
            state.sunset.gotBeatportMigrated,
          sunsetRefundAmount:
            action.payload.sunsetRefundAmount ||
            state.sunset.sunsetRefundAmount,
          sunsetRefundCurrency:
            action.payload.sunsetRefundCurrency ||
            state.sunset.sunsetRefundCurrency,
          beatportCreditAmountInUSD:
            action.payload.beatportCreditAmountInUSD ||
            state.sunset.beatportCreditAmountInUSD,
          beatportCouponCode:
            action.payload.beatportCouponCode ||
            state.sunset.beatportCouponCode,
        },
      }
    },
    errorSettingSunset: (state, action) => {
      return {
        ...state,
        isUpdating: false,
        error: action.payload.err.message,
      }
    },
    receiveSunsetModeStatus: (state, action) => {
      return {
        ...state,
        // isFetching: false,
        sunsetModeStatus: action.payload.sunset.sunsetEnabled,
        preSunsetModeStatus: action.payload.sunset.preSunsetEnabled,
      }
    },
  },
})

const sunsetReducer = sunset.reducer

export { sunsetReducer as sunset }

export const {
  requestSunset,
  receiveSunset,
  errorReceivingSunset,
  settingSunset,
  setSunset,
  errorSettingSunset,
  receiveSunsetModeStatus,
} = sunset.actions

export const fetchSunset = () => async dispatch => {
  try {
    dispatch(requestSunset())
    const sunset = await sunsetApi.getSunset()

    if (!sunset || sunset?.error)
      throw new Error(
        sunset?.error?.userDescription || 'Error fetching sunset information'
      )
    return dispatch(receiveSunset({ sunset }))
  } catch (err) {
    dispatch(error({ title: 'Error', message: err.message }))
    return dispatch(errorReceivingSunset({ err }))
  }
}

export const updateSunset = opts => async dispatch => {
  try {
    dispatch(settingSunset())
    const sunset = await sunsetApi.updateSunset(opts)

    if (!sunset || sunset?.error)
      throw new Error(
        sunset?.error?.userDescription || 'Error fetching sunset information'
      )
    return dispatch(setSunset(sunset))
  } catch (err) {
    dispatch(error({ title: 'Error', message: err.message }))
    return dispatch(errorSettingSunset({ err }))
  }
}

export const getSunsetModeStatus = () => async dispatch => {
  try {
    // dispatch(requestMaintenance())
    const sunset = await sunsetApi.getSunsetModeStatus()
    return dispatch(receiveSunsetModeStatus({ sunset }))
  } catch (error) {
    // return dispatch(errorReceivingMaintenance({ error }))
  }
}
